import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(radioAnatomy.keys);

const stripe = definePartsStyle({
  control: {
    border: '2px solid',
    borderColor: 'blue.800',
    w: '1.1em',
    h: '1.1em',
    mr: '0.25em',
    pos: 'relative',
    _checked: {
      _hover: {
        bg: 'white',
      },
      color: 'dynamic.accent',
      borderColor: 'dynamic.accent',
      bg: 'white',
      _before: {
        content: '""',
        display: 'inline-block',
        w: 'calc(100% - 4px)',
        h: 'calc(100% - 4px)',
        rounded: 'full',
        bg: 'dynamic.accent',
      },
    },
  },
  container: {
    cursor: 'pointer',
    _checked: {
      cursor: 'default',
    },
  },
});

export const Radio = defineMultiStyleConfig({
  variants: { stripe },
});
